import { DatePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'
import { I18nService } from '@mmx/shared'

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  transform(value: any, pattern?: string): string {
    const lang = this.i18n.currentLang ?? 'en'
    const datePipe = new DatePipe(lang)
    return datePipe.transform(value, pattern)
  }
}
